<script setup lang="ts">
import packageInfo from "~/package.json";
import { Ibar, Footer, SnackbarManager } from "@frontiers-vue3/public-pages";
import { addPackageToWindowFrontiers } from "~/helpers";
import { useJournalPagesService } from "~/composables/useJournalPagesService";
import ResearchTopicLayoutProxy from "~/components/templates/ResearchTopicLayoutProxy.vue";

addPackageToWindowFrontiers(packageInfo);

const terminology = useTerminologyStore();
const store = useMain();
const researchTopicTemplate = useResearchTopicTemplate();

const jsonLdSchema = useSchemaService().getResearchTopicSchema(
  store.currentResearchTopic
);

useHead({
  title: `${useSanitizeHtml(store.currentResearchTopic.title, {
    ALLOWED_TAGS: ["sub", "sup"]
  })} | ${terminology.getTerm("tenantName")} ${terminology.getTerm(
    "researchTopic"
  )}`,
  script: [
    {
      type: "application/ld+json",
      innerHTML: JSON.stringify(jsonLdSchema)
    }
  ],
  bodyAttrs: {
    class: `body--${researchTopicTemplate}`
  }
});

onBeforeMount(() => {
  store.fetchTotals();
});

const { data } = useAsyncData("ibar-footer", async () => {
  if (import.meta.client) {
    return useNuxtApp().payload.data["ibar-footer"] ?? null;
  }

  const { getIbarComponent, getFooterComponent } = useJournalPagesService();
  const ibar = await getIbarComponent(store.getPrimaryJournalId);
  const footer = await getFooterComponent();
  return { ibar, footer };
});
</script>
<template>
  <button class="BypassBlock__firstEl"></button>
  <a
    href="#main-content"
    class="BypassBlock__wrapper">
    <span class="BypassBlock__button">Skip to main content</span>
  </a>
  <div :theme="store.colorPalette">
    <Ibar
      v-if="data"
      v-bind="data.ibar"
      about-journal-text="About journal" />
    <ResearchTopicLayoutProxy>
      <NuxtPage :keepalive="{ max: 8 }" />
    </ResearchTopicLayoutProxy>
    <Footer
      v-if="data"
      v-bind="data.footer" />
    <SnackbarManager />
  </div>
</template>
<style lang="scss">
.SnackbarManager {
  @media #{$break-md} {
    bottom: 32px;
  }

  @media #{$break-xs} {
    bottom: 16px;
  }
}
</style>
